import dndStructureData from '../data/full_dnd_structure.json';

/**
 * Load DnD structure for browser environment
 * This function ensures the DnD structure is available in the browser
 */
export function loadDndStructureForBrowser() {
  if (typeof window !== 'undefined') {
    // Set the DnD structure on window for use in calculations
    (window as any).dndStructure = dndStructureData;
    console.log('[DnD Loader] DnD structure loaded into browser');
    return dndStructureData;
  }
  return null;
}

/**
 * Get DnD structure from browser or return fallback
 */
export function getDndStructure() {
  if (typeof window !== 'undefined' && (window as any).dndStructure) {
    return (window as any).dndStructure;
  }
  
  // Fallback to imported data
  return dndStructureData;
} 